import { render, staticRenderFns } from "./VaInnerLoading.vue?vue&type=template&id=f8055ebc&scoped=true&"
import script from "./VaInnerLoading.vue?vue&type=script&lang=js&"
export * from "./VaInnerLoading.vue?vue&type=script&lang=js&"
import style0 from "./VaInnerLoading.vue?vue&type=style&index=0&id=f8055ebc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8055ebc",
  null
  
)

export default component.exports